import { UtilityService } from 'lib/ng2-sapmp/src/providers/utility.service';
import { ReviewService } from './shared/providers/review.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ANALYTICS_CONSTANTS, PIVOTS } from 'config';
import { Router, ActivatedRoute } from '@angular/router';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { FormConfigurationModel, FormPropertyModel } from 'lib/ng2-sapmp/src/ui-components/form-builder';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { UserWizardDataService } from './../users-wizard-data-service';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { UserWizardService, AuthenticationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ReviewFormConfigModel, ItemsModel, ReviewServiceModel, ExtProperties, ExtPropertiesItemsModel } from './../shared';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var logoutCurrentUser: any;
declare var ENV_PORTAL;

@Component({
  selector: 'app-manage-users-review',
  templateUrl: './review.component.html',
  providers: [ReviewService, FormBuilderService, UserWizardDataService],
  styleUrls: ['./../manage-users.component.scss']
})
export class ReviewComponent implements OnInit, OnDestroy {
  breadCrumbs: BreadCrumbModel[];
  userWizardObj: UserWizardModel;
  assignFlag: boolean;
  singleUser: boolean;
  configuration: any;
  formConfiguration: FormConfigurationModel;
  userArraylength: number;
  assignUnassignButtonFlag = false;
  selectedUsersCount: number;
  accordionList: boolean[];
  accordionflag: boolean;
  reviewServiceObj: ReviewServiceModel;
  userWizardModel: UserWizardModel;
  formValue: any;
  nextButtonFlag: boolean[];
  editFlag: boolean[];
  reviewFormConfigModel: ReviewFormConfigModel;
  dcmCodeArray: Array<string>;
  user: UserProfileModel;
  unassignServiceObject: any;
  items: any[];
  totalLicenses: any;
  csrPermissionAssignUnassignButton: boolean;
  errorMessage: string;
  pivots: Array<MobilePivotModel>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private reviewService: ReviewService,
    private utilityService: UtilityService,
    private breadCrumbService: BreadCrumbService,
    private userWizardDataService: UserWizardDataService,
    private userWizardService: UserWizardService,
    private authenticationService: AuthenticationService,
    private pageloaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.userWizardObj = new UserWizardModel();
    this.userWizardObj.selectedUserList = [];
    this.userWizardObj.selectedProductList = [];
    this.formConfiguration = new FormConfigurationModel();
    this.formConfiguration.formProperty = [];
    this.accordionList = [];
    this.nextButtonFlag = [];
    this.editFlag = [];
    this.dcmCodeArray = [];
    this.items = [];
    this.pivots = new Array<MobilePivotModel>();
    this.csrPermissionAssignUnassignButton = this.utilityService.checkFieldPermission('review.assignUnassign',
      JSON.parse(sessionStorage.getItem('permissions')).perm);
    this.pageloaderService.setPageLoaderStatus(false);
    this.configuration = [];
  }

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.pageloaderService.setPageLoaderStatus(false);
    this.userWizardObj = JSON.parse(sessionStorage.getItem('assign-wizard'));
    if (this.userWizardObj === null
      || !!!this.userWizardObj.selectedUserList
      || this.userWizardObj.selectedUserList.length <= 0
    ) {
      this.router.navigate(['/home']);
    } else {
      // document.title = 'AT&T Business Console - Manage users - Review';
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.user = JSON.parse(sessionStorage.getItem('user')).user;
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);

      for (const user of this.userWizardObj.selectedProductList) {
        this.dcmCodeArray.push(user.dcmCode);
      }
      this.userWizardModel = this.userWizardService.fetchSessionData();
      if (PIVOTS[this.userWizardModel.previousUrl]) {
        this.pivots.push({ label: PIVOTS[this.userWizardModel.previousUrl], routerLink: this.userWizardModel.previousUrl });
      }
      this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
      this.userWizardService.setPivot(this.pivots);
      this.selectedUsersCount = this.userWizardObj.selectedUserList.length;
      this.accordionflag = true;
      this.reviewServiceObj = new ReviewServiceModel();
      this.reviewServiceObj.items = [];
      const requestObject = {
        'dcmCodes': this.dcmCodeArray,
        'configurationType': 'licenseConfigurations',
      };
      const actionObject = {
        'action': '',
        'licenseClientId': ''
      };

      if (this.userWizardObj.selectedProductList.length < this.userWizardObj.selectedUserList.length) {
        this.singleUser = false;
      } else {
        this.singleUser = true;
      }
      if (this.userWizardObj.actionType === 'UNASSIGN') {
        this.assignUnassignButtonFlag = true;
        this.assignFlag = false;
        if (this.userWizardObj.selectedUserList.length > 1) {
          this.userWizardObj.selectedUserList.forEach((value, index) => {
            actionObject.action = 'UNASSIGN';
            actionObject.licenseClientId = value.licenseClientId;
            const temporaryObject = <any>JSON.parse(JSON.stringify(actionObject));
            this.items.push(temporaryObject);
          });
          this.openAccordion(0);
        } else {
          actionObject.action = 'UNASSIGN';
          actionObject.licenseClientId = this.userWizardObj.selectedUserList[0].licenseClientId;
          this.items[0] = actionObject;
        }
        /* else if (this.userWizardObj.selectedProductList.length > 1) {
          this.userWizardObj.selectedProductList.forEach((value, index) => {
            actionObject.action = 'UNASSIGN';
            actionObject.licenseClientId = this.userWizardObj.selectedUserList[0].licenseClientId;
            let temporaryObject = <any>JSON.parse(JSON.stringify(actionObject));
            this.items.push(temporaryObject);
          });
          this.openAccordion(0);
        } */

        this.totalLicenses = this.items.length;
        this.pageloaderService.setPageLoaderStatus(true);
      } else {
        this.assignUnassignButtonFlag = false;
        this.assignFlag = true;
        this.reviewService.configurations(this.utilityService.getEnvConfig().productSpecificationUrl, requestObject)
          .subscribe(respobj => {
            this.configuration = this.filterLicenseConfigurations(respobj);
            try {
              this.configuration.forEach((value, index) => {
                const selectedProduct = this.userWizardObj.selectedProductList.find((data) => data.dcmCode === value.dcmCode);
                if (selectedProduct) {
                  this.configuration[index].displayName = selectedProduct.productName;
                }
              });
            } catch (exception) {
              console.log(exception);
            }
            let count = 0;
            if (this.userWizardObj.selectedUserList.length > 1) {
              this.totalLicenses = this.userWizardObj.selectedUserList.length;
              for (const user of this.userWizardObj.selectedUserList) {
                this.reviewServiceObj.items.push(new ItemsModel());
                this.reviewServiceObj.items[count].action = this.userWizardObj.actionType;
                this.reviewServiceObj.items[count].employeeClientId = this.userWizardObj.selectedUserList[count].clientId;
                this.reviewServiceObj.items[count].serviceClientId = this.userWizardObj.selectedProductList[0].clientId;
                this.reviewServiceObj.items[count].extProperties = new ExtProperties();
                this.reviewServiceObj.items[count].extProperties.items = [];
                // actionObject.action = 'UNASSIGN';
                // actionObject.licenseClientId = this.userWizardObj.selectedUserList[count].licenseClientId;
                // let temporaryObject = <any>JSON.parse(JSON.stringify(actionObject))
                // this.items.push(temporaryObject);
                this.editFlag[count] = false;
                this.nextButtonFlag[count] = true;
                this.accordionList.push(false);
                if (this.configuration.length > 0) {
                  this.formConfiguration.formProperty.push(new FormPropertyModel());
                  const tempObj = <any>JSON.parse(JSON.stringify(this.configuration[0].licenseConfigurations));
                  this.userWizardObj.selectedUserList[count].formConfigurations = tempObj;
                }
                count++;
              }
            } else if (this.userWizardObj.selectedProductList.length > 1) {
              for (const respCOnfigObj of this.configuration) {
                const user = this.userWizardObj.selectedProductList.find((data) => (data.dcmCode === respCOnfigObj.dcmCode));
                this.reviewServiceObj.items.push(new ItemsModel());
                this.reviewServiceObj.items[count].action = this.userWizardObj.actionType;
                this.reviewServiceObj.items[count].employeeClientId = this.userWizardObj.selectedUserList[0].clientId;
                this.reviewServiceObj.items[count].serviceClientId = user.clientId;
                this.reviewServiceObj.items[count].extProperties = new ExtProperties();
                this.reviewServiceObj.items[count].extProperties.items = [];
                // actionObject.action = 'UNASSIGN';
                //  actionObject.licenseClientId = this.userWizardObj.selectedUserList[0].licenseClientId;
                //  this.items[0] = actionObject;
                const formPropertyModl = new FormPropertyModel();
                formPropertyModl.formStatus = false;
                this.formConfiguration.formProperty.push(formPropertyModl);
                count++;
              }
              if (this.userWizardObj.selectedProductList.length !== this.configuration.length) {
                const filteredProductList = this.filterNotAvailbleProducts();
                filteredProductList.forEach((value) => {
                  this.reviewServiceObj.items.push(new ItemsModel());
                  const index = this.reviewServiceObj.items.length - 1;
                  this.reviewServiceObj.items[index].action = this.userWizardObj.actionType;
                  this.reviewServiceObj.items[index].employeeClientId = this.userWizardObj.selectedUserList[0].clientId;
                  this.reviewServiceObj.items[index].serviceClientId = value.clientId;
                  this.reviewServiceObj.items[index].extProperties = new ExtProperties();
                  this.reviewServiceObj.items[index].extProperties.items = [];
                });
              }
              this.totalLicenses = this.userWizardObj.selectedProductList.length;
            } else {
              this.totalLicenses = 1;
              this.reviewServiceObj.items.push(new ItemsModel());
              this.reviewServiceObj.items[0].action = this.userWizardObj.actionType;
              this.reviewServiceObj.items[0].employeeClientId = this.userWizardObj.selectedUserList[0].clientId;
              this.reviewServiceObj.items[0].serviceClientId = this.userWizardObj.selectedProductList[0].clientId;
              this.reviewServiceObj.items[0].extProperties = new ExtProperties();
              this.reviewServiceObj.items[0].extProperties.items = [];
              // actionObject.action = 'UNASSIGN';
              // actionObject.licenseClientId = this.userWizardObj.selectedUserList[0].licenseClientId;
              // this.items[0] = actionObject;
            }
            this.userArraylength = this.userWizardObj.selectedUserList.length;
            if (this.configuration.length === 0) {
              this.assignUnassignButtonFlag = true;
            }
            this.openAccordion(0);
            this.pageloaderService.setPageLoaderStatus(true);
          }, error => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
            this.handleError(error);
          });
      }
      this.userWizardDataService.createPageLoadProperties([],
        this.router.routerState.snapshot.url, 'Manageusers Page - Step4',
        ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_USER_REVIEW);
      const message = this.userWizardObj.actionType === 'ASSIGN' ? 'Assign product licenses' : 'Un-assign product licenses';
      this.userWizardService.setMessage(message);
    }
  }

  handleError = (error, assignUnassignError?) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      try {
        let isNotError;
        if (error.status === 401) {
          this.errorMessage = 'Session expired.Please login again.';
          logoutCurrentUser(true);
        } if (error.status === 400) {
          isNotError = true;
          const responseError = error.error[0];
          if (responseError && responseError.length > 0) {
            responseError.forEach(element => {
              if (element.errorDescription) {
                const errorDes = JSON.parse(element.errorDescription);
                this.errorMessage = errorDes.errorMessage;
                isNotError = false;
              }
            });
          }
          if (isNotError) {
            this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
          }
        } else if (assignUnassignError) {
          /* this.errorMessage = 'Your request to ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'Assign' : 'un-assign')
             + ' product licenses was Unsuccessful';*/
             // tslint:disable-next-line:max-line-length
          this.errorMessage = 'We were unable to process your request to ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'Assign' : 'un-assign')
            + ' product licenses.If you need help, call ' + ((ENV_PORTAL === 'fnabc') ? '800.574.7000' : '866.241.6568') + ' (TDD/TTY 866.241.6567) Monday - Friday, 7 a.m. - 9 p.m. ET. Or you can chat with an expert during weekday calling hours, and from 8 a.m. - 5 p.m. ET on Saturday and Sunday.';
        } else {
          this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
        }
      } catch (exception) {
        console.log(exception);
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  toggleTooltip(event) {
    const targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  getFormConfigDetails(formOutputvalue, user, rowIndex: number, dcmCode?: string) {
    this.formValue = formOutputvalue.value;
    console.log(this.userWizardObj.selectedUserList);
    const extpropArray = [];
    Object.keys(formOutputvalue.value).forEach((key, value) => {
      const extPropertiesItemsModel = new ExtPropertiesItemsModel();
      extPropertiesItemsModel.name = key;
      extPropertiesItemsModel.value = formOutputvalue.value[key];
      if (this.userWizardObj.selectedUserList.length > 0) {
        const config = this.configuration[0].licenseConfigurations.find((data) => (
          data.formControlName === key && data.elementType === 'dropdown'));
        if (config) {
          extPropertiesItemsModel.value = formOutputvalue.value[key].value;
        }
      } else if (this.userWizardObj.selectedProductList.length > 1) {
        const configs = this.configuration.find((value) => (dcmCode === value.dcmCode));
        if (configs && configs.length > 0) {
          const config = configs.licenseConfigurations.find((data) => (
            data.formControlName === key && data.elementType === 'dropdown'));
          if (config) {
            extPropertiesItemsModel.value = formOutputvalue.value[key].value;
          }
        }
      }
      extpropArray.push(extPropertiesItemsModel);
    });
    let count = 0;
    if (this.userWizardObj.selectedUserList.length > 1) {
      for (const config of this.configuration[0].licenseConfigurations) {
        if (extpropArray[count].name === config.formControlName) {
          this.reviewServiceObj.items[rowIndex].extProperties.items[count] = extpropArray[count];
        }
        count++;
      }
    } else {
      for (const config of this.configuration[rowIndex].licenseConfigurations) {
        if (extpropArray[count].name === config.formControlName) {
          this.reviewServiceObj.items[rowIndex].extProperties.items[count] = extpropArray[count];
        }
        count++;
      }
    }

    if (rowIndex !== undefined && (this.userWizardObj.selectedUserList.length > 1 || this.userWizardObj.selectedProductList.length > 1)) {
      if (formOutputvalue.valid) {
        this.formConfiguration.formProperty[rowIndex].formStatus = true;
      } else {
        this.formConfiguration.formProperty[rowIndex].formStatus = false;
      }
      let formValidFlag = false;
      if (this.userWizardObj.selectedUserList.length > 1) {
        formValidFlag = this.checkFormValid(this.formConfiguration);
        if (formOutputvalue.valid && formValidFlag) {
          this.assignUnassignButtonFlag = true;
        } else {
          this.assignUnassignButtonFlag = false;
        }
      } else {
        formValidFlag = this.checkFormValid(this.formConfiguration);
        if (formOutputvalue.valid && formValidFlag) {
          this.assignUnassignButtonFlag = true;
        } else {
          this.assignUnassignButtonFlag = false;
        }
      }
    } else {
      if (formOutputvalue.valid) {
        this.assignUnassignButtonFlag = true;
      } else {
        this.assignUnassignButtonFlag = false;
      }
    }
  }

  openAccordion(rowIndex?: number) {
    if (this.assignFlag === true) {
      if (this.singleUser === false) {
        if (rowIndex !== undefined) {
          this.accordionList[rowIndex] = !this.accordionList[rowIndex];
        }
      }
    } else {
      this.accordionflag = !this.accordionflag;
    }
  }

  cancel() {
    sessionStorage.removeItem('showSuccess');
    this.stepindicatorService.removeStep('manageUsers');
    // this.userWizardDataService.cancel(this.userWizardModel.previousUrl);
    this.router.navigate(['/manageUsers/users'], { relativeTo: this.activatedRoute });
  }

  next(i) {
    let count = 0;
    this.reviewServiceObj.items[i].action = this.userWizardObj.actionType;
    for (const iteratingData of this.reviewServiceObj.items[i].extProperties.items) {
      this.reviewFormConfigModel = new ReviewFormConfigModel();
      for (const iterateData of this.configuration[0].licenseConfigurations) {
        if (iteratingData.name === iterateData.formControlName) {
          this.userWizardObj.selectedUserList[i].formConfigurations[count].initialValue = iteratingData.value;
          delete this.userWizardObj.selectedUserList[i].formConfigurations[count].fields;
          this.reviewFormConfigModel.label = iterateData.label;
          this.reviewFormConfigModel.value = iteratingData.value;
          this.userWizardObj.selectedUserList[i].formProperties.push(this.reviewFormConfigModel);

        }
      }

      count++;
    }
    this.nextButtonFlag[i] = false;
    if (!(this.nextButtonFlag[i] || this.accordionList[i + 1])) {
      this.openAccordion(i + 1);
    }
  }

  checkFormValid(formConfiguration) {
    let count = -1;
    for (const obj of formConfiguration.formProperty) {
      count++;
      if (count !== formConfiguration.formProperty.length) {
        if (obj.formStatus === false) {
          return false;
        }
      }
    }
    return true;
  }

  edit(i) {
    this.nextButtonFlag[i] = true;
    this.userWizardObj.selectedUserList[i].formProperties = [];
  }

  assignUnassign() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.unassignServiceObject = {
      'items': this.items
    };
    if (this.userWizardObj.actionType === 'UNASSIGN') {
      this.reviewServiceObj = this.unassignServiceObject;
    }
    const url = this.utilityService.getEnvConfig().bulkAssignUnAssignUrl + this.user.companyId + '/licenses/bulk/';
    this.reviewService.assignUnassign(url, this.reviewServiceObj)
      .subscribe(respobj => {
        if (respobj.totalUsers && respobj.totalErrorUsers && (respobj.totalUsers === respobj.totalErrorUsers)) {
          this.pageloaderService.setPageLoaderStatus(true);
          this.handleError('error', true);
        } else {
          this.userWizardDataService.removeUserWizard();
          this.reviewService.createAdobeEventProperties(this.dcmCodeArray, respobj, 'SUCCESS', 'formResponse');
          this.stepindicatorService.removeStep('manageUsers');
          let successMessage = '';
          if (respobj.status && (respobj.status === 'COMPLETED')) {
            successMessage = 'We\'ve successfully ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'assigned' : 'unassigned') + ' ' +
              + this.totalLicenses + ' of ' + this.totalLicenses + ' licenses.';
              // tslint:disable-next-line:max-line-length
            /* successMessage = 'Your request to ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'assigned' : 'unassigned') + ' product licenses was successful.';*/
          } else if (respobj.totalErrorUsers && respobj.totalUsers) {
            successMessage = 'We\'ve successfully ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'assigned' : 'unassigned') + ' ' +
              + (this.totalLicenses - respobj.totalErrorUsers) + ' of ' + this.totalLicenses +
               ((this.totalLicenses > 1) ? ' licenses.' : ' license.') + 'We were unable to ' +
              ((this.userWizardObj.actionType === 'ASSIGN') ? 'assign' : 'unassign') + ' ' +
              + (respobj.totalErrorUsers) + ((respobj.totalErrorUsers > 1) ? ' licenses.' : ' license.') +
              // tslint:disable-next-line:max-line-length
              'If you need help, call 866.241.6588 (TTY 866.241.6567) Monday - Friday, from 7 a.m. - 9 p.m. ET. You can also chat with an expert during weekday calling hours, and from 8 a.m. - 5.pm ET on Saturday and Sunday.';
          } else if (respobj.status && (respobj.status === 'FAILED')) {
            // tslint:disable-next-line:max-line-length
            successMessage = 'We were unable to process your request to' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'assigned' : 'unassigned') + ' product licenses. If you need help, call 866.241.6568 (TTY: 866.241.6567) Monday - Friday, 7 a.m. - 9 p.m. ET. Or you can chat with an expert during weekday calling hours, and from 8 a.m. - 5 p.m. ET on Saturday and Sunday.';
            /* successMessage = 'Your request to ' + ((this.userWizardObj.actionType === 'ASSIGN') ? 'assigned' : 'unassigned') + ' product licenses was successful.';*/
          }
          this.userWizardDataService.createPageLoadProperties([], '/virtual/manageUsers/confirmation', 'Manageusers Page - Confirmation',
            ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_USER_CONFIRM, 'virtual');
          this.utilityService.setSuccessMessage(successMessage);
          this.pageloaderService.setPageLoaderStatus(true);
          this.breadCrumbService.removeLastBreadCrumb();
          this.userWizardDataService.cancel(this.userWizardModel.previousUrl);
        }
      }, error => {
        this.reviewService.createAdobeEventProperties(undefined, undefined, 'FAILURE', 'formResponse', error.status, error.statusText);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
  }

  private filterLicenseConfigurations(responseLicenseConfigurations): any[] {
    if (responseLicenseConfigurations && responseLicenseConfigurations.length > 0) {
      return responseLicenseConfigurations.filter((data) => ((data.licenseConfigurations) && (data.licenseConfigurations.length > 0)));
    } else {
      return [];
    }
  }

  /**
   * Here filtering not available products in License configurations
   */
  private filterNotAvailbleProducts(): any[] {
    if (this.configuration.length !== 0) {
      const filterdProducts = [];
      this.userWizardObj.selectedProductList.forEach((value) => {
        const isNotAvaibleInLicenseConfiguration = this.configuration.filter((data) => (data.dcmCode === value.dcmCode));
        if (isNotAvaibleInLicenseConfiguration.length === 0) {
          filterdProducts.push(value);
        }
      });
      return filterdProducts;
    } else {
      return this.userWizardObj.selectedProductList;
    }

  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
